import { GridSortModel } from "@mui/x-data-grid";

export type SubmissionSortField = "time_updated" | "time_submitted";
export type SubmissionSortOrder = "desc" | "asc";

export interface SubmissionSort {
  sortBy: SubmissionSortField;
  sortOrder: SubmissionSortOrder;
}

export const SUBMISSION_SORT_FIELDS: SubmissionSortField[] = [
  "time_updated",
  "time_submitted",
];

export const DEFAULT_SUBMISSION_SORT: SubmissionSort = {
  sortBy: "time_updated",
  sortOrder: "desc",
};

const isSortField = (field: unknown): field is SubmissionSortField =>
  SUBMISSION_SORT_FIELDS.includes(field as SubmissionSortField);

/** Filters persisted before `sortBy` existed have no field, so fall back to the default. */
export const sortFromFilters = (filters: {
  sortBy?: string | null;
  sortOrder?: string | null;
}): SubmissionSort => ({
  sortBy: isSortField(filters.sortBy)
    ? filters.sortBy
    : DEFAULT_SUBMISSION_SORT.sortBy,
  sortOrder: filters.sortOrder === "asc" ? "asc" : "desc",
});

export const toGridSortModel = (sort: SubmissionSort): GridSortModel => [
  { field: sort.sortBy, sort: sort.sortOrder },
];

export const fromGridSortModel = (model: GridSortModel): SubmissionSort => {
  const [item] = model;
  if (!item || !isSortField(item.field)) {
    return DEFAULT_SUBMISSION_SORT;
  }
  return {
    sortBy: item.field,
    sortOrder: item.sort === "asc" ? "asc" : "desc",
  };
};

/** Column props for a date column the list can be sorted by from its header. */
export const sortableDateColumn = {
  sortable: true,
  sortingOrder: ["desc", "asc"] as SubmissionSortOrder[],
};
